export enum PurchaseFlow {
    RETAIL = 'RETAIL',
    ENROLLMENT = 'ENROLLMENT',
    AUTOSHIP = 'AUTOSHIP',
    PERSONAL = 'PERSONAL',
    FPC5PERCENT = 'FPC-5PERCENT'
}